import { useRef, useState, useEffect } from "react";
import "./FormKpiBuilderNew.scss";
import axios from "axios";
import { useNavigate, useLocation } from "react-router-dom";
import { ReactTabulator } from "react-tabulator";
import { toast } from "react-toastify";
import Loader from "../Loader";

const FormKpiBuilderNew = () => {
  const refNumber1 = useRef(null);
  const refNumber2 = useRef(null);
  const tableRefKPI = useRef(null); //fetch fields table
  const withOutCoRadioCheckbox = useRef(null);
  const andRadioCheckbox = useRef(null);
  const orRadioCheckbox = useRef(null);
  const operator = useRef(null);
  const field = useRef(null);
  const titleRef = useRef(); //kpi title
  const dataValue = useRef(null);
  const tableRefKPIOne = useRef(null); //conditions table
  const checkBoxRef = useRef(null);
  const [value, setValue] = useState(null);
  const [shart, setShart] = useState("");
  const [shartText, setShartText] = useState("بدون شرط");
  const [tabulatorDataState, setTabulatorDataState] = useState([]); //General data of the fetch fileds table
  const [tabulatorDataStateOne, setTabulatorDataStateOne] = useState([]); //General data of the conditions table
  const [selectedRow, setSelectedRow] = useState();
  const location = useLocation();
  const navigateTo = useNavigate();
  const [disableCheck, setDisableCheck] = useState("withOutCondition");
  const [type, setType] = useState("string");
  const [FieldData, setFieldData] = useState([]);
  const [entityConditionFields, setEntityConditionFields] = useState([]);
  const [indicator, setIndicator] = useState([]);
  const [operatorValue, setOperatorValue] = useState({
    value: "",
    text: "",
  });

  useEffect(() => {
    if (tabulatorDataStateOne.length > 0) {
      setDisableCheck("hasCondition");
    } else {
      setDisableCheck("withOutCondition");
    }
  }, [tabulatorDataStateOne]);

  useEffect(() => {
    let datas = {};
    if (location.state) {
      datas = {
        id: location.state.value.id,
        hasKpiId: location.state.value.hasKpiId,
        kpiOptions: location.state.value.kpiOptions,
      };
      setValue(datas);
    }
    setEntityConditionFields(datas.kpiOptions.entityConditionFields);
    setIndicator(datas.kpiOptions.indicator);
  }, [location]);

  function rowClickHandler(e, row) {
    row.getTable().getSelectedRows().length === 0
      ? setSelectedRow()
      : setSelectedRow(row);
  }

  const tableOptions = { layout: "fitDataTable", selectable: 1 };

  const tableColumnsTwo = [
    {
      title: "آیدی",
      field: "id",
      visible: false,
    },
    {
      title: "شرط",
      field: "andOrText",
    },
    {
      title: "مقدار شرط ارسالی به بک",
      field: "andOr",
      visible: false,
    },
    {
      title: "نام فیلد",
      field: "fieldText",
    },
    {
      title: " نام فیلد ارسالی به بک",
      field: "field",
      visible: false,
    },
    {
      title: "عملگر",
      field: "operatorText",
    },
    {
      title: "عملگر ارسالی به بک",
      field: "operator",
      visible: false,
    },
    {
      title: "مقدار",
      field: "valueText",
    },
    {
      title: "مقدار ارسالی به بک",
      field: "value",
      visible: false,
    },
    {
      title: "حذف",
      headerSort: false,
      formatter: "buttonCross", // width: 60,
      maxWidth: 100,
      headerHozAlign: "center",
      cellClick: function (e, cell) {
        const table = tableRefKPIOne.current.table;
        const rowId = cell.getData().id;
        const tableData = deleteRowHandler(tabulatorDataStateOne, rowId, table);
        setTabulatorDataStateOne(tableData);
      },
    },
  ];

  const deleteRowHandler = (tableArray, rowId, tableName) => {
    const table = [...tableArray];
    let newDataTable = table.filter((row) => row.id !== rowId);

    //Always the first row of the condition table must be unconditional
    if (tableName === tableRefKPIOne.current.table) {
      if (newDataTable.length > 0) {
        newDataTable.forEach((v, index) => {
          if (index === 0) {
            v.andOr = "";
            v.andOrText = "بدون شرط";
          }
        });
      }
    }
    return newDataTable;
  };

  const tableColumns = [
    {
      title: "نام فیلد",
      field: "nameField",
    },
    {
      title: "ارسالی به بک",
      field: "nameFieldValue",
      visible: false,
    },
    {
      title: "نوع واکشی",
      field: "typeOfSelect",
    },
    {
      title: "نوع واکشی ارسالی به بک",
      field: "typeOfSelectValue",
      visible: false,
    },
    {
      title: "حذف",
      headerSort: false,
      formatter: "buttonCross", // width: 60,
      maxWidth: 80,
      headerHozAlign: "center",
      cellClick: function (e, cell) {
        const table = tableRefKPI.current.table;
        const rowId = cell.getData().id;
        const tableData = deleteRowHandler(tabulatorDataState, rowId, table);
        setTabulatorDataState(tableData);
      },
    },
  ];

  //Add rows to the condition table
  const addRowPleaseOne = () => {
    let tempDataTabulator = [];

    //General data of the condition table
    let tableDataPlease = tableRefKPIOne.current.table.getData();

    //در صورت درست بود شرط ها یه ردیف به جدول اضافه کن
    if (field.current.value === "") {
      toast.error("فیلد مورد نظر خود را انتخاب کنید");
      return;
    }
    if (operatorValue.value === "") {
      toast.error("عملگر مورد نظر خود را انتخاب کنید");
      return;
    }
    if (type === "select" && dataValue.current.value === "") {
      toast.error("گزینه مورد نظر خود را انتخاب کنید!");
      return;
    } else if (
      (type === "string" || type === "number") &&
      dataValue.current.value === ""
    ) {
      toast.error("فیلد مقدار را پر کنید");
      return;
    }
    //Check to see if the bet has been selected or not
    debugger;
    if (disableCheck === "hasCondition") {
      if (shart === "") {
        toast.error("باید شرط را تعیین کنید!");
        return;
      }
    }
    let newSetShart = shart;
    let newSetShartText = shartText;
 
    if (disableCheck === "withOutCondition") {
      if(shart !== "") {
        newSetShart = "";
        newSetShartText = "بدون شرط";
      }
    }

    let objectToAddOne = {
      id: `Row${Math.random()}`,
      andOr: newSetShart,
      andOrText: newSetShartText,
      field: field.current.value,
      fieldText: field.current.options[field.current.selectedIndex].text,
      operator: operatorValue.value,
      operatorText: operatorValue.text,
      value: dataValue.current.value,
      valueText:
        type === "select"
          ? dataValue.current.options[dataValue.current.selectedIndex].text
          : dataValue.current.value,
    };

    if (tableDataPlease.length > 0) {
      tableDataPlease.forEach((v) => {
        const tempO = { ...objectToAddOne };
        delete tempO.id;
        const tempV = { ...v };
        delete tempV.id;

        //If it was a duplicate, can you please not allow it to be added to the table?
        if (JSON.stringify(tempV) === JSON.stringify(tempO)) {
          toast.error("این مورد قبلا به جدول اضافه شده است.");
          return;
        }
        tempDataTabulator.push({
          id: v.id,
          andOr: v.andOr,
          field: v.field,
          operator: v.operator,
          value: v.value,
          andOrText: v.andOrText,
          fieldText: v.fieldText,
          operatorText: v.operatorText,
          valueText: v.valueText,
        });
      });
      tempDataTabulator.push(objectToAddOne);
    } else {
      tempDataTabulator.push(objectToAddOne);
    }
    console.log(tempDataTabulator);
    setTabulatorDataStateOne(tempDataTabulator);
    //خالی شدن فرم روی صفحه
    field.current.value = "";
    field.current.options[field.current.selectedIndex].text = "انتخاب کنید";
    setOperatorValue({ value: "", text: "" });
    operator.current.value = "";
    operator.current.options[operator.current.selectedIndex].text =
      "انتخاب کنید";
    setType("srting");
    dataValue.current.value = "";
  };

  const addRowPlease = () => {
    if (refNumber1.current.value === "") {
      toast.error("لطفا یک گزینه را در بخش فیلد انتخاب کنید");
      return;
    }
    if (refNumber2.current.value === "") {
      toast.error("لطفا یک گزینه را در بخش نوع واکشی انتخاب کنید");
      return;
    }

    let tempDataTabulator = [];

    //General data of the Fetch fields table
    let tableDataPlease = tableRefKPI.current.table.getData();

    let objectToAdd = {
      id: `Row${Math.random()}`,
      nameField:
        refNumber1.current.options[refNumber1.current.selectedIndex].text,
      nameFieldValue: refNumber1.current.value,
      typeOfSelect:
        refNumber2.current.options[refNumber2.current.selectedIndex].text,
      typeOfSelectValue: refNumber2.current.value,
    };

    if (tableDataPlease.length > 0) {
      tableDataPlease.forEach((v) => {
        const tempO = { ...objectToAdd };
        delete tempO.id;
        const tempV = { ...v };
        delete tempV.id;
        //If it was a duplicate, can you please not allow it to be added to the table?
        if (JSON.stringify(tempV) === JSON.stringify(tempO)) {
          toast.error("این مورد قبلا به جدول اضافه شده است.");
          return;
        }
        tempDataTabulator.push({
          id: v.id,
          nameField: v.nameField,
          nameFieldValue: v.nameFieldValue,
          typeOfSelect: v.typeOfSelect,
          typeOfSelectValue: v.typeOfSelectValue,
        });
      });
      tempDataTabulator.push(objectToAdd);
    } else {
      tempDataTabulator.push(objectToAdd);
    }
    console.log(tempDataTabulator);
    setTabulatorDataState(tempDataTabulator);
  };

  //فیلد های شرطی
  const fieldChangeHandler = (e) => {
    let target = e.target.value;
    entityConditionFields.forEach((v) => {
      if (v.value === target) {
        setType(v?.type);
        setFieldData(v?.data);
      }
    });
  };

  //مقدار عملگر و تکستشو میگیره
  const operatorCHangeHnadler = (e) => {
    const temp = { ...operatorValue };
    temp.value = e.target.value;
    temp.text = operator.current.options[operator.current.selectedIndex].text;
    setOperatorValue(temp);
  };

  // مقدار شرط و تکستشو میگیره
  const conditionHandler = (e) => {
    setShart(e.target.value);
    setShartText(e.target.nextSibling.innerText);
  };

  const sendFormDataToAliTaheri = () => {
    debugger;
    let titleToSend = titleRef.current.value;
    let indicators = [];
    let fetchs = [];
    let conditions = [];

    //i wanna take the values of CheckBoxes
    let elements = checkBoxRef.current.getElementsByTagName("input");
    // import Data to indicators
    for (let element of elements) {
      if (element.checked) {
        indicators.push(element.value);
      }
    }
    // tabulator data to fetch Array
    let tabulatorData = tableRefKPI.current.table.getData();
    tabulatorData.forEach((item) => {
      fetchs.push({ enName: item.nameFieldValue, arg: item.typeOfSelectValue });
    });

    // tabulator data to conditions Array
    let tabulatorDataONE = tableRefKPIOne.current.table.getData();
    tabulatorDataONE.forEach((v) => {
      conditions.push({
        field: v.field,
        operator: v.operator,
        value: v.value,
        andOr: v.andOr,
      });
    });

    // ورودی ها رو پر کرده یا نه؟
    if (titleToSend === "") {
      toast.error("لطفا یک عنوان وارد کنید.");
      return;
    }
    if (indicators.length < 1) {
      toast.error("فیلد های شاخص خالی هستند!");
      return;
    }
    if (fetchs.length < 1) {
      toast.error("فیلد های واکشی را پر کنید!");
      return;
    }

    const url = localStorage.getItem("apiUrl") + "/atprint/";
    const sendRequest = axios
      .post(
        url,
        {
          id: value.id,
          options: {
            title: titleToSend,
            indicator: indicators,
            fetch: fetchs,
            conditions: conditions,
            hasChart: 0,
          },
        },
        {
          headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
        }
      )
      .then(({ data }) => {
        if (data.status) {
          toast.success(data.message);
          navigateTo(-1);
        } else {
          toast.error(data.message);
        }
      })
      .catch((err) => {
        console.log(
          typeof err.response !== "undefined"
            ? err.response.data.message
            : err.message
        );
        console.log(err.response.data.message);
        console.log(err.message);
        let msg =
          typeof err.response !== "undefined" ? err.response.data : err.message;
        toast.error(msg);
      });
  };

  return value !== null ? (
    <div className="wrapper_formkpi">
      <div className="form__">
        <div className="input__group">
          <label>عنوان</label>
          <input
            type="text"
            placeholder="عنوان مورد نظر خود را وارد کنید"
            id={"titleForKPI"}
            ref={titleRef}
          />
        </div>
        <div className="line__">
          <label>فیلد یا فیلدهای شاخص</label>
        </div>
        <div className="flex_chackbox" ref={checkBoxRef}>
          {indicator.map((i, index) => (
            <div className="checkbox__" key={"IN" + index}>
              <input
                value={i?.value}
                type={"checkbox"}
                id={`indicator+${index}`}
              />
              <label htmlFor={`indicator+${index}`}>{i?.label}</label>
            </div>
          ))}
        </div>
      </div>
      <div className="form_dom_two">
        <div className="line__">
          <label>فیلد یا فیلدهای واکشی</label>
        </div>
        <div className="flex_group_">
          <div className="select__group">
            <label>فیلد</label>
            <select id={"refNumber1"} ref={refNumber1}>
              <option value="" hidden>
                انتخاب کنید
              </option>
              {value?.kpiOptions?.fetch?.map((v, index) => (
                <option value={v?.value} key={index + "F"}>
                  {v?.label}{" "}
                </option>
              ))}
            </select>
          </div>
          <div className="select__group">
            <label>نوع واکشی</label>
            <select id={"refNumber2"} ref={refNumber2}>
              <option value="" hidden>
                انتخاب کنید
              </option>
              <option value={"MIN"}>کمترین</option>
              <option value={"MAX"}>بیشترین</option>
              <option value={"AVG"}>میانگین</option>
              <option value={"SUM"}>جمع</option>
              <option value={"COUNT"}>تعداد</option>
            </select>
          </div>
        </div>
        <div className="btn__parent">
          <button onClick={addRowPlease}>افزودن</button>
        </div>
      </div>
      <div className="table_holder">
        <ReactTabulator
          ref={tableRefKPI}
          columns={tableColumns}
          data={tabulatorDataState}
          options={tableOptions}
          style={{ height: "30vh" }}
          events={{ rowClick: rowClickHandler }}
        />
      </div>
      <div className="form_dom">
        <div className="line__">
          <label>تعریف شرط</label>
        </div>
        <div className="flex_group_">
          <div className="select__group">
            <label>انتخاب فیلد</label>
            <select ref={field} onChange={fieldChangeHandler}>
              <option value="" hidden>
                انتخاب کنید
              </option>
              {entityConditionFields.map((v, index) => (
                <option value={v?.value} key={index + "r"}>
                  {v?.label}
                </option>
              ))}
            </select>
          </div>
          <div className="select__group">
            <label>عملگر</label>
            <select
              name="operator"
              ref={operator}
              onChange={operatorCHangeHnadler}
              defaultValue={operatorValue.value}
            >
              <option value="" hidden>
                انتخاب کنید
              </option>
              <option value={"="}>مساوی</option>
              <option value={">="}>بزرگتر مساوی</option>
              <option value={"<="}>کوچکتر مساوی</option>
              <option value={"<"}>کوچکتر</option>
              <option value={">"}>بزرگتر</option>
              <option value={"!="}>مخالف</option>
            </select>
          </div>
        </div>
        <div className="flex_group_">
          {type === "select" ? (
            <div className="select__group">
              <label>مقدار</label>
              <select name="value" ref={dataValue}>
                <option value="" hidden>
                  انتخاب کنید
                </option>
                {FieldData?.map((v, index) => (
                  <option value={v?.value} key={index + "field"}>
                    {v?.label}
                  </option>
                ))}
              </select>
            </div>
          ) : (
            <div className="input__group half_width">
              <label>مقدار</label>
              <input
                type={
                  type === "string"
                    ? "text"
                    : type === "number"
                    ? "number"
                    : "text"
                }
                placeholder="اطلاعات خود را وارد کنید"
                ref={dataValue}
              />
            </div>
          )}
          <div className="condition_box">
            <label className="title_condition">شرط</label>
            <div className="radio__box">
              <input
                type="radio"
                id="withOutCondition"
                value={""}
                ref={withOutCoRadioCheckbox}
                onChange={conditionHandler}
                defaultChecked={disableCheck === "hasCondition" ? false : true}
                disabled={disableCheck === "withOutCondition" ? false : true}
              />
              <label htmlFor="withOutCondition">بدون شرط</label>
            </div>
            <div className="radio__box">
              <input
                type="radio"
                id="and_"
                value={"AND"}
                ref={andRadioCheckbox}
                name="andOr"
                onChange={conditionHandler}
                defaultChecked={disableCheck === "withOutCondition" && false}
                disabled={disableCheck === "hasCondition" ? false : true}
              />
              <label htmlFor="and_">و</label>
            </div>
            <div className="radio__box">
              <input
                type="radio"
                id="or_"
                value={"OR"}
                ref={orRadioCheckbox}
                name="andOr"
                onChange={conditionHandler}
                defaultChecked={disableCheck === "withOutCondition" && false}
                disabled={disableCheck === "hasCondition" ? false : true}
              />
              <label htmlFor="or_">یا</label>
            </div>
          </div>
        </div>
        <div className="btn__parent">
          <button onClick={addRowPleaseOne}>افزودن</button>
        </div>
      </div>
      {/* جدول تعریف شرط */}
      <div className="table_holder">
        <ReactTabulator
          ref={tableRefKPIOne}
          columns={tableColumnsTwo}
          data={tabulatorDataStateOne}
          // dataChanged={(newData) => console.log('dataChanged', newData)}
          options={tableOptions}
          style={{ height: "30vh" }}
          events={{ rowClick: rowClickHandler }}
        />
      </div>
      <div className="btn__parent">
        <button onClick={sendFormDataToAliTaheri}>ثبت نهایی</button>
      </div>
    </div>
  ) : (
    <Loader />
  );
};

export default FormKpiBuilderNew;
